import React from 'react';
import {Link} from 'react-router-dom';

import {ROUTES} from '../../contants';

import JoinTeamImg from '../../assets/images/join-team.png';

export const JoinTeam = () => (
  <div className="join-team">
    <div className="container">
      <div className="join-team__wr">
        <div className="join-team__image">
          <img src={JoinTeamImg} alt="join-team image" />
        </div>
        <div className="join-team__content">
          <h4>Join Our Team</h4>
          <p>
            We are seeking experienced and reliable drivers, with 2+ years of CDL experience, to join our team.
            We are committed to fostering a respectful and supportive work environment where every team member is valued.
            If you're looking to join a company that truly appreciates its drivers, we encourage you to apply today.
          </p>
          <Link to={ROUTES.HIRE} className="btn btn--black">
            <span>SEE JOBS</span>
          </Link>
        </div>
      </div>
    </div>
  </div>
);
